import { IColors } from "./colors";
import { ITypography } from "./typography";
import { IShadows } from "./shadow";
import { ISpacing } from "./spacing";
import { IBorderRadius, IBorderWidth } from "./border";

export interface ISingleTheme {
    name: string;
    colors: IColors;
    typography: ITypography;
    shadows: IShadows;
    spacing: ISpacing;
    borderRadius: IBorderRadius;
    borderWidth: IBorderWidth;
}

/**
 * @deprecated will be removed in the future releases
 */
export interface IAppTheme {
    v2: ISingleTheme;
}

export type TColor = keyof IColors;

export interface ITheme {
    light: ISingleTheme;
    dark: ISingleTheme;
}
